module.exports = __webpack_public_path__ + "static/media/vf-button-skirt.a31d02c1.svg";